import React from "react";
import {connect} from "react-redux";
import {
  List,
  Datagrid,
  TextField,
  DateField,
  DeleteButton,
  GET_LIST
} from "admin-on-rest";
import { Redirect } from 'react-router-dom';
import CreateButton from "../../../components/CRM/CreateGiftCardButton";
import ReferenceField from "../../../components/ReferenceField";
import { crudGetList as crudGetListAction, CRUD_GET_LIST_SUCCESS } from '../../../admin-on-rest/src/actions/dataActions';
import restClient from "../../../restClient";

import Avatar from "material-ui/Avatar";

import {listStyle} from "./style";

const linkToRecord = (basePath, id) => `${basePath}/${encodeURIComponent(id)}`;
class FullNameField extends React.Component {
  render() {
    const props = {...this.props};
    const record = {...props.record};

    return (
      <div style={listStyle.textFieldContainer}>
        <span style={listStyle.textFieldStyle}>
          {record.first_name} {record.last_name}
        </span>
      </div>
    );
  }
}

class PhoneFieldBase extends React.Component {
  render() {
    const props = {...this.props};
    const record = {...props.record};
    const avatar = props.avatar;

    return (
      <div style={listStyle.textFieldContainer}>
        <Avatar src={avatar} style={{minWidth: 40}} />
        <span style={listStyle.textFieldStyle}>
          {record.phone}
        </span>
      </div>
    );
  }
}

const mapStateToProps2 = (state) => {
  return {
    avatar: state.images.avatar_logo
  };
};

const PhoneField = connect(mapStateToProps2)(PhoneFieldBase);

class GiftCardDataListBase extends React.Component {
  state = {
    redirect: false,
    recordID: null,
    stateUpdated: false
  }

  handleRowSelection = value => {
    if (Array.isArray(value)) {
      this.props.record.selectedRow = value;
    }
    if (
      this.props.record.selectedRow[0] ||
      this.props.record.selectedRow[0] === 0
    ) {
      const recordID = this.props.record.list.ids[this.props.record.selectedRow[0]];

      this.setState({
        recordID: recordID
      });

      this.setRedirect();
    }
  };

  setRedirect = () => {
    this.setState({
      redirect: true
    })
  }

  async componentWillMount(){    
    const reqParams = {
      pagination: {
        page: 1,
        perPage: 10
      },
      sort: {
        fields: ["id"]
      },
      params: {},
      filter: { state: "new" }
    };

    await restClient(GET_LIST, "gift_cards", reqParams)
		.then(() => {
      this.setState({ stateUpdated: true });
		})
		.catch(error => {
			console.error(error);
		});
  }
  

  render() {
    const props = {...this.props};
    const basePath = 'gift_cards';
    const recordID = this.state.recordID;
    if (recordID && this.state.redirect) {
      return <Redirect to={`/${linkToRecord(basePath, recordID)}`} />
    }    
    
    return this.props.giftCardsEnabled ? (
      <React.Fragment>
        <span style={{display: "none"}}>{this.props.giftCardsEnabled}</span>
        <List 
          {...props}
          title="resources.giftCards.name"
          actions={<CreateButton basePath={basePath} />}
          filter={{ state: "new" }}
        >      
          <Datagrid
            options={{
              multiSelectable: false,
              selectable: true,
              onRowSelection: this.handleRowSelection
            }}
            bodyOptions={{
              displayRowCheckbox: false,
              deselectOnClickaway: false,
              showRowHover: true
            }}
            rowOptions={{
              selectable: true
            }}
          >

            {this.state.stateUpdated && <ReferenceField
              label="resources.customers.fields.phone"
              source="customer_id"
              reference="customers"
              linkType={false}
              allowEmpty
            >
              <PhoneField source="phone" />
            </ReferenceField>}
            
            {this.state.stateUpdated && <ReferenceField
              label="resources.customers.fields.customer"
              source="customer_id"
              reference="customers"
              linkType={false}
              allowEmpty
            >
              <FullNameField source="first_name,last_name" />
            </ReferenceField>}

            {this.state.stateUpdated && <ReferenceField
              label="resources.customers.fields.email"
              source="customer_id"
              reference="customers"
              linkType={false}
              allowEmpty
            >
              <TextField source="email" />
            </ReferenceField>}

            <DateField
              label="resources.customers.fields.createdAt"
              source="created_at"
            />
            
            <TextField source="state" />
            
            <DeleteButton />          

          </Datagrid>
        </List>        
      </React.Fragment>
    ) : (
      <React.Fragment>
        <List 
          {...props}
          title="resources.giftCards.name"
          actions={null}
          filter={{ state: "new" }}
        >      
          <Datagrid
            options={{
              multiSelectable: false,
              selectable: true,
              onRowSelection: this.handleRowSelection
            }}
            bodyOptions={{
              displayRowCheckbox: false,
              deselectOnClickaway: false,
              showRowHover: true
            }}
            rowOptions={{
              selectable: true
            }}
          >

            <ReferenceField
              label="resources.customers.fields.phone"
              source="customer_id"
              reference="customers"
              linkType={false}
              allowEmpty
            >
              <PhoneField source="phone" />
            </ReferenceField>
            
            <ReferenceField
              label="resources.customers.fields.customer"
              source="customer_id"
              reference="customers"
              linkType={false}
              allowEmpty
            >
              <FullNameField source="first_name,last_name" />
            </ReferenceField>

            <ReferenceField
              label="resources.customers.fields.email"
              source="customer_id"
              reference="customers"
              linkType={false}
              allowEmpty
            >
              <TextField source="email" />
            </ReferenceField>

            <DateField
              label="resources.customers.fields.createdAt"
              source="created_at"
            />
            
            <TextField source="state" />
            
            <DeleteButton />          

          </Datagrid>
        </List>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    record: state.admin.resources[props.resource],
    giftCardsEnabled: state.giftCards.giftCardsEnabled
  };
};

const GiftCardDataList = connect(
  mapStateToProps,
  {
    crudGetList: crudGetListAction,
    CRUD_GET_LIST_SUCCESS
  }
)(GiftCardDataListBase);

export default GiftCardDataList;



// WEBPACK FOOTER //
// ./src/containers/CRM/GiftCards/GiftCardDataList.js